import React, { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { loginUser, selectUser } from "../../config/slice/userSlice";
import Input from "../Input";
import Layout from "../layout/layout";
import Profiletabs from "./Profiletabs";
import { axiosInstance } from "../../config/AxiosInstance";
import { toast } from "react-toastify";

const Profile = () => {
  const [profileImg, setProfileImg] = useState({ profile: "", url: "" });
  const dispatch = useDispatch();
  const ImageUploader = (event) => {
    const files = event.target.files;
    setProfileImg({
      ...profileImg,
      profile: files[0],
      url: files ? URL.createObjectURL(files[0]) : "",
    });
  };
  const { userData } = useSelector(selectUser);
  const ref = useRef();

  const Imageinp = () => ref.current.click();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: {
      full_name: userData?.full_name || "",
      email: userData?.email || "",
      address: userData?.address || "",
      city: userData?.city || "",
      post_code: userData?.post_code || "",
      country: userData?.country || "",
    },
  });
  const onSubmit = (data) => {
    const body = { ...data, image: profileImg.profile };
    console.log(body, "<===profileImg.profile");
    const formdata = new FormData();
    for (const key in body) {
      if (body.hasOwnProperty.call(body, key)) {
        const element = body[key];
        formdata.append(key, element);
      }
    }

    console.log(formdata, "<===formdata");
    axiosInstance
      .post("profile", formdata)
      .then((response) => {
        const resData = response.data;
        console.log(resData);
        if (resData.status) {
          dispatch(loginUser(resData.data));
          toast.success(resData.message);
        } else {
          toast.error(resData.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Layout>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title">
              <div className="row align-items-center justify-content-between">
                <div className="col-xl-4">
                  <div className="page-title-content">
                    <h3>Profile</h3>
                    <p className="mb-2">Welcome Ekash Finance Management</p>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="breadcrumbs">
                    <Link to="/">Home </Link>
                    <span>
                      <i className="fi fi-rr-angle-small-right" />
                    </span>
                    <Link to="#">Edit Profile</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-12 col-xl-12">
            <Profiletabs />
            <div className="row">
              <div className="col-xxl-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Personal Information</h4>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="row g-4">
                        <div className="col-xxl-12 col-12 mb-3">
                          <div className="d-flex align-items-center">
                            <img
                              onClick={Imageinp}
                              className="me-3 rounded-circle me-0 me-sm-3"
                              src={
                                userData?.image
                                  ? userData?.image
                                  : profileImg.url
                                  ? profileImg.url
                                  : "images/avatar/3.jpg"
                              }
                              width={55}
                              height={55}
                              alt=""
                            />
                            <div className="media-body">
                              <h4 className="mb-0">{userData?.full_name}</h4>
                            </div>
                          </div>
                        </div>
                        <input
                          type="file"
                          onChange={ImageUploader}
                          accept="image/*"
                          ref={ref}
                          className="d-none"
                        />

                        <div className="col-xxl-6 col-xl-6 col-lg-6">
                          <Input
                            name="full_name"
                            type="text"
                            label={"Full Name"}
                            control={control}
                            className={"form-label"}
                            rules={{
                              required: "Full Name is Required",
                            }}
                            errors={errors}
                          />
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6">
                          <Input
                            name="email"
                            type="email"
                            label={"Email"}
                            control={control}
                            className={"form-label"}
                            rules={{
                              required: "Email is Required",
                              pattern: /^\S+@\S+$/i,
                            }}
                            errors={errors}
                          />
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6">
                          <Input
                            name="address"
                            type="text"
                            label={"Address"}
                            control={control}
                            className={"form-label"}
                            rules={{
                              required: "Address is Required",
                            }}
                            errors={errors}
                          />
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6">
                          <Input
                            name="city"
                            type="city"
                            label={"City"}
                            control={control}
                            className={"form-label"}
                            rules={{
                              required: "City is Required",
                            }}
                            errors={errors}
                          />
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6">
                          <Input
                            name="country"
                            type="country"
                            label={"Country"}
                            control={control}
                            className={"form-label"}
                            rules={{
                              required: "Country is Required",
                            }}
                            errors={errors}
                          />
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6">
                          <Input
                            name="post_code"
                            type="number"
                            label={"Post Code"}
                            control={control}
                            className={"form-label"}
                            rules={{
                              required: "Post Code is Required",
                            }}
                            errors={errors}
                          />
                        </div>
                        {/* <div className="col-xxl-6 col-xl-6 col-lg-6">
                          <label className="form-label">Country</label>
                          <input className="form-control" />
                        </div> */}
                        <div className="col-12">
                          <button
                            type="submit"
                            className="btn btn-primary pl-5 pr-5"
                          >
                            Save Profile
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="col-xxl-6 col-xl-6 col-lg-6">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Change Password</h4>
                  </div>
                  <div className="card-body">
                    <form action="#">
                      <div className="row g-3">
                        <div className="col-12 mb-3">
                          <label className="form-label">New Email</label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email"
                          />
                        </div>
                        <div className="col-12 mb-3">
                          <label className="form-label">New Password</label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="**********"
                          />
                          <small className="mt-2 mb-0 d-block">
                            Enable two factor authencation on the security page
                          </small>
                        </div>
                        <div className="col-12 col-12 mb-3">
                          <button className="btn btn-primary">Save</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
